"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var War = exports["default"] = /*#__PURE__*/function (_Core) {
  function War(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, War);
    _this = _callSuper(this, War, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.on = _this.on.bind(_this);
    _this._events = {};
    _this.ready = false;
    _this.checkReadyRetryCount = 0;
    _this.maxCheckReadyRetries = 20;
    _this.checkReadyRetryDelay = 3000;
    _this.myServices = ["War"];
    _this.init();
    return _this;
  }
  (0, _inherits2["default"])(War, _Core);
  return (0, _createClass2["default"])(War, [{
    key: "detectServices",
    value: function detectServices() {
      var _this2 = this;
      return Object.keys(this.services).some(function (key) {
        return _this2.myServices.includes(key);
      });
    }
  }, {
    key: "getCheckReady",
    value: function () {
      var _getCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var payload, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              payload = {
                action: "System.War.CheckReady",
                uuid: (0, _uuid.v4)(),
                origin: "sdk-" + this.appName,
                timestamp: Number(BigInt(Date.now()) * 1000000n),
                request_uuid: "",
                data: "{}"
              };
              _context.next = 1;
              return this.connection.invoke("messaging", payload);
            case 1:
              _logger["default"].info("Check Ready", "Sent readiness check", "War");
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              _logger["default"].error("Check Ready Failed", _t.message, "War");
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getCheckReady() {
        return _getCheckReady.apply(this, arguments);
      }
      return getCheckReady;
    }()
  }, {
    key: "retryCheckReady",
    value: function () {
      var _retryCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this3 = this;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.checkReadyRetryCount < this.maxCheckReadyRetries) {
                this.checkReadyRetryCount++;
                _logger["default"].warn("War Ready", "Not ready yet. Retrying (".concat(this.checkReadyRetryCount, "/").concat(this.maxCheckReadyRetries, ")"), "Print");
                setTimeout(function () {
                  _this3.getCheckReady();
                }, this.checkReadyRetryDelay);
              } else {
                _logger["default"].error("Print Ready", "Max retries reached. Still not ready.", "Print");
                this.trigger("ready", false);
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function retryCheckReady() {
        return _retryCheckReady.apply(this, arguments);
      }
      return retryCheckReady;
    }()
  }, {
    key: "invokeMessaging",
    value: function () {
      var _invokeMessaging = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(action) {
        var _this4 = this;
        var params,
          _args3 = arguments;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              params = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                var uuid = (0, _uuid.v4)();
                var payload = {
                  uuid: uuid,
                  action: action,
                  origin: "sdk-".concat(_this4.appName),
                  timestamp: Number(BigInt(Date.now()) * 1000000n),
                  data: JSON.stringify(params)
                };

                // Set up timeout for this specific request
                var timeout = setTimeout(function () {
                  reject(new Error("Timeout waiting for response to ".concat(action)));
                }, 30000);

                // Create a unique handler for this request
                var _responseHandler = function responseHandler(data) {
                  // Only accept responses that match our specific UUID AND are from the War service
                  if ((data.requestUuid === uuid || data.uuid === uuid) && data.origin === "War" && data.action === "".concat(action, ".Response")) {
                    clearTimeout(timeout);
                    _this4.connection.off("messaging", _responseHandler);
                    resolve(data);
                  }
                };

                // Add the unique listener for this request
                _this4.connection.on("messaging", _responseHandler);

                // Send the message
                _this4.connection.invoke("messaging", payload);
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function invokeMessaging(_x) {
        return _invokeMessaging.apply(this, arguments);
      }
      return invokeMessaging;
    }()
  }, {
    key: "getPackages",
    value: function () {
      var _getPackages = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return this.invokeMessaging("System.War.Packages");
            case 1:
              return _context4.abrupt("return", _context4.sent);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getPackages() {
        return _getPackages.apply(this, arguments);
      }
      return getPackages;
    }()
  }, {
    key: "getPackageUpdates",
    value: function () {
      var _getPackageUpdates = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return this.invokeMessaging("System.War.PackageUpdates");
            case 1:
              return _context5.abrupt("return", _context5.sent);
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getPackageUpdates() {
        return _getPackageUpdates.apply(this, arguments);
      }
      return getPackageUpdates;
    }()
  }, {
    key: "getPackageDetails",
    value: function () {
      var _getPackageDetails = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        return _regenerator["default"].wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 1;
              return this.invokeMessaging("System.War.PackagesDetails");
            case 1:
              return _context6.abrupt("return", _context6.sent);
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getPackageDetails() {
        return _getPackageDetails.apply(this, arguments);
      }
      return getPackageDetails;
    }()
  }, {
    key: "packagesAction",
    value: function () {
      var _packagesAction = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(actionData) {
        return _regenerator["default"].wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 1;
              return this.invokeMessaging("System.War.PackagesAction", actionData);
            case 1:
              return _context7.abrupt("return", _context7.sent);
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function packagesAction(_x2) {
        return _packagesAction.apply(this, arguments);
      }
      return packagesAction;
    }()
  }, {
    key: "connectivityCheck",
    value: function () {
      var _connectivityCheck = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        return _regenerator["default"].wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 1;
              return this.invokeMessaging("System.War.ConnectivityCheck");
            case 1:
              return _context8.abrupt("return", _context8.sent);
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function connectivityCheck() {
        return _connectivityCheck.apply(this, arguments);
      }
      return connectivityCheck;
    }()
  }, {
    key: "setApplication",
    value: function () {
      var _setApplication = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(appData) {
        return _regenerator["default"].wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 1;
              return this.invokeMessaging("System.War.SetApplications", appData);
            case 1:
              return _context9.abrupt("return", _context9.sent);
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function setApplication(_x3) {
        return _setApplication.apply(this, arguments);
      }
      return setApplication;
    }()
  }, {
    key: "getApplications",
    value: function () {
      var _getApplications = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee0() {
        return _regenerator["default"].wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.next = 1;
              return this.invokeMessaging("System.War.Applications");
            case 1:
              return _context0.abrupt("return", _context0.sent);
            case 2:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this);
      }));
      function getApplications() {
        return _getApplications.apply(this, arguments);
      }
      return getApplications;
    }()
  }, {
    key: "startApplications",
    value: function () {
      var _startApplications = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee1(appData) {
        return _regenerator["default"].wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.next = 1;
              return this.invokeMessaging("System.War.ApplyConfiguration", appData);
            case 1:
              return _context1.abrupt("return", _context1.sent);
            case 2:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this);
      }));
      function startApplications(_x4) {
        return _startApplications.apply(this, arguments);
      }
      return startApplications;
    }()
  }, {
    key: "getDisplayConfig",
    value: function () {
      var _getDisplayConfig = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10() {
        return _regenerator["default"].wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 1;
              return this.invokeMessaging("System.War.GetDisplayConfig");
            case 1:
              return _context10.abrupt("return", _context10.sent);
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getDisplayConfig() {
        return _getDisplayConfig.apply(this, arguments);
      }
      return getDisplayConfig;
    }()
  }, {
    key: "forceReboot",
    value: function () {
      var _forceReboot = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee11() {
        return _regenerator["default"].wrap(function (_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 1;
              return this.invokeMessaging("System.War.ForceReboot");
            case 1:
              return _context11.abrupt("return", _context11.sent);
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function forceReboot() {
        return _forceReboot.apply(this, arguments);
      }
      return forceReboot;
    }()
  }, {
    key: "detectDisplays",
    value: function () {
      var _detectDisplays = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee12() {
        return _regenerator["default"].wrap(function (_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 1;
              return this.invokeMessaging("System.War.DetectDisplays");
            case 1:
              return _context12.abrupt("return", _context12.sent);
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function detectDisplays() {
        return _detectDisplays.apply(this, arguments);
      }
      return detectDisplays;
    }()
  }, {
    key: "serviceInformation",
    value: function () {
      var _serviceInformation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee13() {
        return _regenerator["default"].wrap(function (_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 1;
              return this.invokeMessaging("System.War.ServiceInformation");
            case 1:
              return _context13.abrupt("return", _context13.sent);
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function serviceInformation() {
        return _serviceInformation.apply(this, arguments);
      }
      return serviceInformation;
    }()
  }, {
    key: "refreshCmsConfig",
    value: function () {
      var _refreshCmsConfig = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee14() {
        return _regenerator["default"].wrap(function (_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 1;
              return this.invokeMessaging("System.War.RefreshCmsConfig");
            case 1:
              return _context14.abrupt("return", _context14.sent);
            case 2:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function refreshCmsConfig() {
        return _refreshCmsConfig.apply(this, arguments);
      }
      return refreshCmsConfig;
    }()
  }, {
    key: "uninstallDevice",
    value: function () {
      var _uninstallDevice = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee15() {
        return _regenerator["default"].wrap(function (_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 1;
              return this.invokeMessaging("System.War.UninstallDevice");
            case 1:
              return _context15.abrupt("return", _context15.sent);
            case 2:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function uninstallDevice() {
        return _uninstallDevice.apply(this, arguments);
      }
      return uninstallDevice;
    }()
  }, {
    key: "getDeviceProfile",
    value: function () {
      var _getDeviceProfile = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee16() {
        return _regenerator["default"].wrap(function (_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 1;
              return this.invokeMessaging("System.War.GetDeviceProfile");
            case 1:
              return _context16.abrupt("return", _context16.sent);
            case 2:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function getDeviceProfile() {
        return _getDeviceProfile.apply(this, arguments);
      }
      return getDeviceProfile;
    }()
  }, {
    key: "getRemoteActions",
    value: function () {
      var _getRemoteActions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee17() {
        return _regenerator["default"].wrap(function (_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 1;
              return this.invokeMessaging("System.War.GetRemoteActions");
            case 1:
              return _context17.abrupt("return", _context17.sent);
            case 2:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function getRemoteActions() {
        return _getRemoteActions.apply(this, arguments);
      }
      return getRemoteActions;
    }()
  }, {
    key: "changeRemoteActions",
    value: function () {
      var _changeRemoteActions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee18(remoteData) {
        return _regenerator["default"].wrap(function (_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 1;
              return this.invokeMessaging("System.War.ChangeRemoteActions", remoteData);
            case 1:
              return _context18.abrupt("return", _context18.sent);
            case 2:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function changeRemoteActions(_x5) {
        return _changeRemoteActions.apply(this, arguments);
      }
      return changeRemoteActions;
    }()
  }, {
    key: "getDevice7Cp",
    value: function () {
      var _getDevice7Cp = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee19() {
        return _regenerator["default"].wrap(function (_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 1;
              return this.invokeMessaging("System.War.GetDevice7Cp");
            case 1:
              return _context19.abrupt("return", _context19.sent);
            case 2:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function getDevice7Cp() {
        return _getDevice7Cp.apply(this, arguments);
      }
      return getDevice7Cp;
    }()
  }, {
    key: "handleMessage",
    value: function () {
      var _handleMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee20(message) {
        var statusChange, applyConfig, data, _JSON$parse, ready, _t2;
        return _regenerator["default"].wrap(function (_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (!(message.origin === "sdk-".concat(this.appName))) {
                _context20.next = 1;
                break;
              }
              return _context20.abrupt("return");
            case 1:
              _t2 = message.action;
              _context20.next = _t2 === "System.SDK.ServiceNotification.Response" ? 2 : _t2 === "System.PrintService.StatusNotifications" ? 4 : _t2 === "System.DisplayManager.ApplyConfiguration" ? 5 : _t2 === "System.ServiceNotification" ? 6 : _t2 === "System.War.Notify.Ready" ? 9 : 10;
              break;
            case 2:
              if (this.myServices.includes(message.origin)) {
                _context20.next = 3;
                break;
              }
              return _context20.abrupt("return");
            case 3:
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              return _context20.abrupt("return");
            case 4:
              statusChange = JSON.parse(message.data);
              this.trigger("statusChange", statusChange);
              return _context20.abrupt("return");
            case 5:
              applyConfig = JSON.parse(message.data);
              this.trigger("applyConfiguration", applyConfig);
              return _context20.abrupt("return");
            case 6:
              if (this.myServices.includes(message.origin)) {
                _context20.next = 7;
                break;
              }
              return _context20.abrupt("return");
            case 7:
              data = JSON.parse(message.data);
              _context20.next = 8;
              return this.connection.invoke("messaging", {
                uuid: (0, _uuid.v4)(),
                action: "".concat(data.serviceIdentification, ".ServiceNotification.Response"),
                origin: "sdk-".concat(this.appName),
                timestamp: Number(BigInt(Date.now()) * 1000000n),
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-".concat(this.appName),
                  publicKey: this.publicKey
                })
              });
            case 8:
              this.services[message.origin] = data;
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              return _context20.abrupt("return");
            case 9:
              try {
                _JSON$parse = JSON.parse(message.data), ready = _JSON$parse.ready;
                if (ready === true) {
                  this.checkReadyRetryCount = 0;
                  if (!this.ready) {
                    this.ready = true;
                    this.trigger("ready", true);
                    _logger["default"].success("Initialization", "Module is now fully ready", "War");
                  }
                } else {
                  this.retryCheckReady();
                }
              } catch (e) {
                _logger["default"].error("Parse error", "Invalid ready payload: " + e.message, "War");
              }
              return _context20.abrupt("return");
            case 10:
              return _context20.abrupt("continue", 11);
            case 11:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function handleMessage(_x6) {
        return _handleMessage.apply(this, arguments);
      }
      return handleMessage;
    }()
  }, {
    key: "init",
    value: function init() {
      _logger["default"].info("Initialization", "WAR module initialization started", "War");
      if (!this.detectServices()) {
        _logger["default"].warn("Initialization", "No services found yet.", "War");
      } else {
        this.ready = true;
        this.trigger("ready", true);
      }
      this.connection.on("messaging", this.handleMessage.bind(this));
      this.getCheckReady();
    }
  }]);
}(_core["default"]);